import { useMutation } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";

import { ISaveLMIA } from "../../interfaces/services";
import { ILMIA } from "../../interfaces/entities";

import useToast from "../useToast";

import { saveLMIA } from "../../services/lmias";

export interface IPayload {
    employer_id: number;
    payload: ISaveLMIA;
    operation: string;
    setIsProcessing: Function;
};

export interface IResponse {
    error?: string;
    message: string;
    statusCode: number;
    data: ILMIA;
};

const useSaveLMIA = () => {
    const navigate = useNavigate();
    // const queryClient = useQueryClient();

    const { addToast } = useToast();

    const mutationFn = async (data: IPayload): Promise<IResponse> => {
        return await saveLMIA(data.payload);
    };

    return useMutation({
        mutationFn,
        onSuccess: (response: IResponse, variables: IPayload) => {
            if (response?.statusCode === 200) {
                addToast({
                    type: 'success',
                    title: 'LMIA details saved successfully.',
                });

                if (variables.operation === 'create') {
                    setTimeout(() => {
                        // navigate(`/employers/${variables.employer_id}/lmias/${response?.data.id}/details`);
                        navigate(`/employers/${variables.employer_id}/lmias`);
                    }, 500);
                } else {
                    // queryClient.invalidateQueries({ queryKey: ['lmia_details'] });
                    setTimeout(() => {
                        navigate(`/employers/${variables.employer_id}/lmias`);
                    }, 500);
                };
            };
        },
        onError: (error: IResponse, variables: IPayload) => {
            addToast({
                type: 'error',
                title: 'Error occured',
                message: error.message
            });
        },
        onSettled: (data: IResponse | undefined, error: IResponse | null, variables: IPayload) => {
            variables.setIsProcessing(false);
        },
    });
};

export default useSaveLMIA;